import { render, staticRenderFns } from "./AgendaCardSmall.vue?vue&type=template&id=0e461a06"
import script from "./AgendaCardSmall.vue?vue&type=script&lang=js"
export * from "./AgendaCardSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports